var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIconSellerEditModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)",
    fill: "CurrentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99384 2.45317C7.62584 2.45317 7.32717 2.75183 7.32717 3.11983V7.7865H2.6605C2.2925 7.7865 1.99384 8.08517 1.99384 8.45317C1.99384 8.82117 2.2925 9.11983 2.6605 9.11983H7.32717V13.7865C7.32717 14.1545 7.62584 14.4532 7.99384 14.4532C8.36184 14.4532 8.6605 14.1545 8.6605 13.7865V9.11983H13.3272C13.6952 9.11983 13.9938 8.82117 13.9938 8.45317C13.9938 8.08517 13.6952 7.7865 13.3272 7.7865H8.6605V3.11983C8.6605 2.75183 8.36184 2.45317 7.99384 2.45317Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconSellerEditModal);
export default __webpack_public_path__ + "static/media/PlusIcon-Seller-EditModal.2f1c491da690dd053da765d695ce643f.svg";
export { ForwardRef as ReactComponent };